import { render, staticRenderFns } from "./TagInterest.vue?vue&type=template&id=5446171a&scoped=true"
import script from "./tagInterest.ts?vue&type=script&lang=ts&external"
export * from "./tagInterest.ts?vue&type=script&lang=ts&external"
import style0 from "./TagInterest.vue?vue&type=style&index=0&id=5446171a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5446171a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5446171a')) {
      api.createRecord('5446171a', component.options)
    } else {
      api.reload('5446171a', component.options)
    }
    module.hot.accept("./TagInterest.vue?vue&type=template&id=5446171a&scoped=true", function () {
      api.rerender('5446171a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-card-stemdoer/tag-interest/TagInterest.vue"
export default component.exports